import React from 'react';

const DashboardStats = ({ firms = [], users = [], loading = false }) => {
  const activeFirms = firms.filter(
    (firm) => firm.status === 'active'
  ).length;

  const activeUsers = users.filter(
    (user) => user.is_active === true
  ).length;

  const stats = [
    {
      label: 'Total Firms',
      value: firms.length,
      icon: '▤',
      color: 'blue',
    },
    {
      label: 'Active Firms',
      value: activeFirms,
      icon: '✓',
      color: 'green',
    },
    {
      label: 'Distributor Users',
      value: users.filter((user) => user.role === 'distributor').length,
      icon: '♙',
      color: 'purple',
    },
    {
      label: 'Active Users',
      value: activeUsers,
      icon: '●',
      color: 'orange',
    },
  ];

  return (
    <section className="dashboard-stats" aria-label="Dashboard statistics">
      {stats.map((stat) => (
        <article className="dashboard-stat-card" key={stat.label}>
          <div className={`dashboard-stat-icon ${stat.color}`}>
            {stat.icon}
          </div>

          <div className="dashboard-stat-content">
            <span className="dashboard-stat-label">{stat.label}</span>
            <strong className="dashboard-stat-value">
              {loading ? '—' : stat.value}
            </strong>
          </div>
        </article>
      ))}
    </section>
  );
};

export default DashboardStats;